import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
import { LicenseQueryKey } from '@/shared/hooks/license/queryKey';
export const useCreateEmployee = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation(model => api.base.post('/api/employee/Create', model).then(res => res.data), {
        onSuccess: result => {
            var _a;
            if (result) {
                const dataCache = DataCacheService.getDataCache();
                (_a = dataCache === null || dataCache === void 0 ? void 0 : dataCache.user) === null || _a === void 0 ? void 0 : _a.push({
                    employeeID: result.employeeID,
                    userID: result.userID,
                    firstName: result.firstName,
                    lastName: result.lastName,
                    isActive: result.isActive,
                    languageCode: result.languageCode,
                    email: result.userEmail,
                });
            }
            queryClient.invalidateQueries([LicenseQueryKey.Info]);
        },
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { createEmployee: mutateAsync, isLoading };
};
export default useCreateEmployee;
